import { useGroupNichesFormModel } from './group-niches-form.model'
import type { IGroupNichesForm } from './group-niches-form.types'
import { GroupNichesFormView } from './group-niches-form.view'

export const GroupNichesForm = ({ handleClose }: IGroupNichesForm) => {
  const groupNichesFormModel = useGroupNichesFormModel({ handleClose })
  return <GroupNichesFormView handleClose={handleClose} {...groupNichesFormModel} />
}
